import { CSSProperties, FC, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import InterestCarousel from '../../../../components/InterestCarousel/InterestCarousel';
import Footer from '../../../../../../components/Footer/Footer';
import { INTEREST_HEIGHT, MOBILE_INTEREST_HEIGHT } from '../Category/constants';
import { useResize } from '../../../../hooks';
import SingleCard from '../../components/SingleCard/SingleCard';
import { getSSRTranslation } from '../../../../../../i18n';
import { CommonPageDataContext } from '../../../../ContextWrapper/WithInterest/CommonPageDataContext.ts';
import { getInterestBackgroundImg } from '../../../../utils';

import './index.scss';
import { useQuery } from '@tanstack/react-query';
import {
  fetchGames,
  GAMES_QUERY_KEY,
} from '@moment/net/classic-fotoscapes/fetch-games.ts';

const Games: FC = () => {
  const { isMobile } = useResize();
  const { interests } = useContext(CommonPageDataContext);
  const { t, i18n } = useTranslation();
  const lang = i18n.language;

  const fetchGamesFunction = useMemo(() => {
    return fetchGames({lang})
  }, [lang])

  const { data } = useQuery({
    queryKey: [GAMES_QUERY_KEY, lang],
    queryFn: fetchGamesFunction
  });

  const gameList = useMemo(() => {
    return data?.items || [];
  }, [data]);

  const interest = useMemo(() => {
    if (interests && gameList.length) {
      const interestGameId = gameList[0].interests[0];
      return interests.interestForId(interestGameId);
    }

    return null;
  }, [gameList, interests]);

  const sectionHeight = useMemo(() => {
    if (isMobile) {
      return MOBILE_INTEREST_HEIGHT;
    }

    return INTEREST_HEIGHT;
  }, [isMobile]);

  const styleList = useMemo(() => {
    const backgroundImage = interest ? getInterestBackgroundImg(interest) : '';

    return {
      '--background-image': `url(${backgroundImage})`,
      height: sectionHeight,
    } as CSSProperties;
  }, [interest, sectionHeight]);

  return (
    <div className="games">
      {/*TODO: Move to new component*/}
      <div
        className="games__container interest-background  interest-background--with-img interest-background--e1f1GsP"
        style={styleList}
      >
        <div className="interest-background__item" />

        <h1 className="games__title">{t('gameTitle')}</h1>

        <h2 className="games__subtitle paragraph--m">{t('gameSubtitle')}</h2>

        <InterestCarousel
          isSmallView={false}
          isMobile={false}
          itemList={gameList}
          renderItem={(item) => {
            const { images, summary, title, owner, brandLogo, sourceLink } =
              item;

            return (
              <SingleCard
                uid={item.uid}
                interestId={item.interests[0]}
                link={sourceLink}
                classList="interest-carousel__cover-look"
                title={getSSRTranslation(title, i18n)}
                imgList={images}
                descriptionLineCount={4}
                description={getSSRTranslation(summary, i18n)}
                owner={owner}
                logoURL={brandLogo}
              />
            );
          }}
        />
      </div>
      <Footer />
    </div>
  );
};

export default Games;
